document.addEventListener("DOMContentLoaded", function () {
  // Read Liquid-generated data from the JSON island
  const data = JSON.parse(document.getElementById('kopstorm-data')?.textContent || '{}');
  const variantSize = data.variantSize || {};

  function decodeHTMLEntities(text) {
    const textArea = document.createElement("textarea");
    textArea.innerHTML = text;
    return textArea.value;
  }

  document.addEventListener("variant:change", function (event) {
    const variant = event.detail?.variant;
    if (!variant) return;
    const guide = document.getElementById("product_sizeguide");
    const sizeInfo = variantSize[variant.id];

    if (guide) {
      guide.innerText = sizeInfo && sizeInfo.trim() ? decodeHTMLEntities(sizeInfo) : "";
    }
  });

  // Country list toggle
  const countryList = document.getElementById("CountryList");
  document.getElementById("selectmarket")?.addEventListener("click", () => {
    countryList?.classList.toggle("display-block");
    countryList?.classList.toggle("display-none");
  });

  document.querySelectorAll(".dicsl").forEach(el => {
    el.addEventListener("click", () => {
      countryList?.classList.remove("display-block");
      countryList?.classList.add("display-none");
    });
  });

  // Market switch button
  const marketSwitch = document.getElementById("marketswitch");
  document.querySelectorAll("#countrylink").forEach(link => {
    link.addEventListener("click", function () {
      const value = this.getAttribute("data-value");
      if (!marketSwitch) return;
      marketSwitch.setAttribute("data-value", value);
      marketSwitch.style.opacity = 1;
      marketSwitch.style.pointerEvents = "auto";
      if (countryList) countryList.style.display = "none";
    });
  });

  if (marketSwitch && !marketSwitch.getAttribute("data-value")) {
    marketSwitch.style.opacity = 0.75;
    marketSwitch.style.pointerEvents = "none";
  }

  // Language selector close
  document.getElementById("language_selector2")?.addEventListener("click", () => {
    const menu = document.getElementById("header-sidebar-menu");
    if (menu) {
      menu.style.opacity = "0";
      menu.style.visibility = "hidden";
      document.documentElement.style.overflow = "auto";
    }
  });

  // Fade effects (throttled with rAF)
  const fadeEls = [".fade_1", ".fade_2", ".fade_3"].map(s => document.querySelector(s)).filter(Boolean);
  if (fadeEls.length) {
    let fadeTicking = false;
    window.addEventListener("scroll", () => {
      if (!fadeTicking) {
        fadeTicking = true;
        requestAnimationFrame(() => {
          fadeEls.forEach(el => { el.style.opacity = el.offsetHeight >= 25 ? 0 : 1; });
          fadeTicking = false;
        });
      }
    }, { passive: true });
  }

  // Language & country triggers
  const triggerToggles = {
    ".trigger_button_1": "CountryList",
    ".trigger_button_2": "LanguageList",
  };

  Object.entries(triggerToggles).forEach(([btnClass, listId]) => {
    document.querySelector(btnClass)?.addEventListener("click", () => {
      const list = document.getElementById(listId);
      if (list) {
        list.style.display = list.style.display === "block" ? "none" : "block";
      }
    });
  });

  // Modal open / close for mp1 & mp2
  document.getElementById("mp2_open_mp1")?.addEventListener("click", () => {
    document.getElementById("mp1")?.classList.add("visible");
    document.getElementById("mp2")?.classList.remove("visible");
  });

  document.getElementById("mp1_open_mp2")?.addEventListener("click", () => {
    document.getElementById("mp2")?.classList.add("visible");
    document.getElementById("mp1")?.classList.remove("visible");
  });

  document.addEventListener("click", function (event) {
    const mp1 = document.getElementById("mp1");
    const mp2 = document.getElementById("mp2");

    if (
      mp1?.classList.contains("visible") &&
      !event.target.closest("#mp1") &&
      !event.target.closest("#mp2_open_mp1")
    ) {
      mp1.classList.remove("visible");
    }

    if (
      mp2?.classList.contains("visible") &&
      !event.target.closest("#mp2") &&
      !event.target.closest("#mp1_open_mp2") &&
      !event.target.closest("[data-localization-modal-trigger]")
    ) {
      mp2.classList.remove("visible");
    }
  });

  // Dropdown animation
  document.querySelectorAll(".trigger_button_2").forEach(button => {
    button.addEventListener("click", () => {
      button.querySelector(".animated-icon")?.classList.toggle("rotate");
    });
  });

  // Product card color selector
  document.querySelectorAll(".product-card").forEach(card => {
    const colorTrigger = card.querySelector(".color-trigger");
    if (!colorTrigger) return;
    const checked = card.querySelector("input[type='radio']:checked");
    if (checked) {
      const label = card.querySelector(`label[for="${checked.id}"]`);
      colorTrigger.textContent = label?.getAttribute("color") || "";
    }

    card.querySelectorAll(".product-card__swatch-list label").forEach(label => {
      label.addEventListener("click", () => {
        const colorValue = label.getAttribute("color");
        colorTrigger.textContent = colorValue;
      });
    });
  });

});
